<template>
  <div>
    <img src="../static/testimonial/success.png" alt="">
  </div>
</template>

<script>
import mcheader from '@/components/Mcheader'
import mcfoot from '@/components/Mcfoot'
export default {
  name: 'Paysuccess',
  components: {
    mcheader,
    mcfoot
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Paysuccess.vue